import React, { useState, useLayoutEffect, useContext, useMemo } from 'react'
import styled from 'styled-components'

interface PropsPipes {
    span: string
    isRealtime: boolean
}
const Pipes = styled.div<PropsPipes>`
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    padding: 5px;
    border: solid 1px #c2c2c2;
    .section-title {
        text-transform: uppercase;
        /* &::after {
            content: ${({ span, isRealtime }) => `'Follow: ${isRealtime ? 'true' : 'false'}  Span: ${span} '`};
            width: 100px;
            padding: 0px 10px;
        } */
    }
`
const eventStore = require('live/components/events/lib/store')('config/datasource-form', {
    enforceDependencies: true
})

const eventActions = require('live/components/events/lib/actions')('config/datasource-form')

interface PipesFormMainProps {
    expression: string
    span: string
    provider: string
}
export default function PipesForm({
    onChange,
    query,
    maxHeight = '100%',
    span,
    follow,
    provider
}: {
    onChange: (props: PipesFormMainProps) => void
    query: string
    span: string
    provider: string
    maxHeight?: string
    follow: boolean
}) {
    const [state, setState] = useState<{
        span: string
        follow: boolean
        provider: string
    }>({ span, follow, provider })

    const actions = useMemo(() => {
        return {
            ...eventActions,
            setChart: function () {
                return false
            },
            setFollow: function (currfollow) {
                setState({ span, provider, follow: currfollow })
                eventActions.setFollow(currfollow)
            },
            setTimespan: function (currSpan) {
                setState({ span: currSpan, follow, provider })
                eventActions.setTimespan(currSpan)
            },
            setProvider: currProvider => {
                setState({ provider: currProvider, follow, span })
                eventActions.setProvider(currProvider)
            }
        }
    }, [])

    const ExpressionPreview = useMemo(() => {
        eventActions.setTimespan(span)
        eventActions.setFollow(follow)

        return require('live/components/forms/ui/expression-preview')(eventStore, actions)
    }, [actions, eventStore, provider])

    return (
        <Pipes
            span={span}
            style={{
                maxHeight: maxHeight
            }}
        >
            <ExpressionPreview
                expressionHasChanged={true}
                readonly={false}
                expressionHasChangedTemplate={<span />}
                data={{
                    provider: provider,
                    expression: query
                }}
                apply={({ expression }) => {
                    onChange({ expression, span: state?.span, provider: state?.provider })
                }}
            />
        </Pipes>
    )
}
